import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { MessageService } from 'primeng/api'

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(
    private messageService: MessageService,
    private translate: TranslateService,
  ) {}

  showToast(
    severity: 'success' | 'error' | 'info' | 'warn' | 'secondary' | 'contrast',
    title: string,
    message: string,
    duration: number = 5000,
  ) {
    this.translate.get([title, message]).subscribe((translations) => {
      this.messageService.add({
        severity: severity,
        summary: translations[title],
        detail: translations[message],
        life: duration,
      })
    })
  }
}
